import React from 'react'
const Loading =()=>{
    return(
        <div className="d-flex justify-content-center" style={{marginTop:'200px'}}>
        <div className="spinner-border" role="status">
        </div>
        </div>
    )
}
export default Loading